import React, { Component } from 'react';
import { Input } from 'react-bootstrap';

export default class DisabledWeightField extends Component {
  render() {
    const { input } = this.props;
    return (
      <Input {...input} disabled standalone type="text" value={this.props.V} addonAfter="lb" onChange={this.props.input.onChange(this.props.V)}/>
    );
  }
}



// WEBPACK FOOTER //
// ./master/jsx/components/Common/weightField.jsx